import React, { useContext, useEffect, useState } from 'react';
// import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getRaqCalendarSchedules } from '../../../store/HR/Raqeeb/raqeebSlice';
import { useParams } from 'react-router-dom';

import PerfectScrollbar from 'react-perfect-scrollbar';

import FullCalendar from '@fullcalendar/react'; // الحزمة الرئيسية
import dayGridPlugin from '@fullcalendar/daygrid'; // عرض الشبكة اليومية
import timeGridPlugin from '@fullcalendar/timegrid'; // عرض الشبكة الزمنية
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import bootstrapPlugin from '@fullcalendar/bootstrap';

import { AppSettings } from '../../../config/app-settings';
import Loading from '../../../components/Shared/Loader/Loading';
// import { Card, CardBody } from '../../../components/card/card';
// import Breadcrumb from '../../../components/Shared/Breadcrumb';

const Calendar = () => {
  const context = useContext(AppSettings);

  const { id } = useParams();
  const dispatch = useDispatch();
  // const { i18n, t } = useTranslation();

  const {
    CalendarSchedules: data,
    CalendarLoading: loading,
    CalendarError: error,
  } = useSelector((state) => state.Raqeeb);

  useEffect(() => {
    dispatch(getRaqCalendarSchedules(id));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  const plugins = [dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin, bootstrapPlugin];
  const headerToolbar = {
    left: 'dayGridMonth,timeGridWeek,timeGridDay',
    center: 'title',
    right: 'prev,next today',
  };
  const buttonText = {
    today: 'Today',
    month: 'Month',
    week: 'Week',
    day: 'Day',
  };
  const views = {
    timeGrid: {
      eventLimit: 6,
    },
  };
  const [events, setEvents] = useState();

  // console.log(events);

  useEffect(() => {
    context.setAppContentFullHeight(true);
    context.setAppContentClass('p-0');

    if (data && Array.isArray(data)) {
      const transformedEvents = data.flatMap((item) => {
        const events = [];

        // إذا كان اليوم إجازة، أضف حدثًا للإجازة
        if (item.isHoliday) {
          events.push({
            id: `${item.id}-holiday`,
            title: item.holidayName || 'إجازة', // اسم الإجازة أو نص افتراضي
            start: item.transDate, // تاريخ الإجازة
            end: item.transDate, // نفس التاريخ
            color: 'red', // لون مميز للإجازة
            display: 'red', // عرض الحدث كخلفية
          });
        }

        // إنشاء البصمات بناءً على countFingerprint
        const fingerprints = Array.from(
          { length: item.countFingerprint === 3 ? 4 : item.countFingerprint },
          (_, index) => ({
            time: item[`fingerprintTime${index + 1}`],
            label: `  -- ( البصمة ${index + 1} )`,
          })
        );

        // إضافة أحداث البصمات
        events.push(
          ...fingerprints
            .filter((fp) => fp.time) // تجاهل البصمات بدون وقت
            .map((fp) => {
              // تحديد اللون بناءً على البصمة
              // let color;
              // switch (fp.label) {
              //   case 'البصمة 1':
              //     color = 'blue';
              //     break;
              //   case 'البصمة 2':
              //     color = 'green';
              //     break;
              //   case 'البصمة 3':
              //     color = 'orange';
              //     break;
              //   case 'البصمة 4':
              //     color = 'red';
              //     break;
              //   default:
              //     color = 'gray'; // لون افتراضي
              // }

              return {
                id: `${item.id}-${fp.label}`,
                title: `${fp.label}`,
                start: fp.time,
                end: fp.time,
                // color: color,
                color: 'green',
              };
            })
        );

        return events;
      });

      setEvents(transformedEvents);
    }

    return function cleanUp() {
      context.setAppContentFullHeight(false);
      context.setAppContentClass('');
    };
  }, [data, context]);

  return (
    <>
      <Loading loading={loading} error={error}>
        <div className="calendar p-3 ">
          <div className="calendar-body">
            <PerfectScrollbar className="h-100">
              <FullCalendar
                plugins={plugins}
                initialView="dayGridMonth"
                themeSystem="bootstrap"
                headerToolbar={headerToolbar}
                buttonText={buttonText}
                events={events}
                views={views}
                // displayEventTime={false} // منع عرض الوقت الافتراضي

                eventTimeFormat={{
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: true, // لتعطيل تنسيق 12 ساعة
                }}
              />
            </PerfectScrollbar>
          </div>
        </div>
      </Loading>
    </>
  );
};

export default Calendar;

// {/* <style>
//     {`
//       .fc-event {
//          margin-bottom: 10px;
//        }
//       `}
//   </style> */}

//   {/* <div className="calendar">
//     <div className="calendar-body">
//       <PerfectScrollbar className="h-100">
//         <FullCalendar
//           plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
//           initialView="dayGridMonth"
//           locale="ar" // دعم اللغة العربية
//           events={events} // الأحداث
//           editable={true} // التعديل على الأحداث
//           selectable={true} // السماح بالتحديد
//           headerToolbar={headerToolbar}
//           buttonText={buttonText}
//           views={views}
//         />
//       </PerfectScrollbar>
//     </div>
//   </div> */}

// useEffect(() => {
//   context.setAppContentFullHeight(true);
//   context.setAppContentClass('p-0');

//   if (data && Array.isArray(data)) {
//     const transformedEvents = data.flatMap((item) => {
//       // إنشاء البصمات بناءً على countFingerprint
//       const fingerprints = Array.from(
//         { length: item.countFingerprint === 3 ? 4 : item.countFingerprint },
//         (_, index) => ({
//           time: item[`fingerprintTime${index + 1}`], // الوصول إلى الوقت بناءً على الترتيب
//           label: `البصمة ${index + 1}`, // تسمية البصمات
//         })
//       );

//       return fingerprints
//         .filter((fp) => fp.time) // تجاهل البصمات بدون وقت
//         .map((fp) => {
//           // تحديد اللون بناءً على البصمة
//           let color;
//           switch (fp.label) {
//             case 'البصمة 1':
//               color = 'blue';
//               break;
//             case 'البصمة 2':
//               color = 'green';
//               break;
//             case 'البصمة 3':
//               color = 'orange';
//               break;
//             case 'البصمة 4':
//               color = 'red';
//               break;
//             default:
//               color = 'gray'; // لون افتراضي
//           }

//           return {
//             id: `${item.id}-${fp.label}`,
//             title: `${fp.label}`,
//             start: fp.time,
//             end: fp.time, // الحدث يظهر كنقطة وقت
//             color: color, // اللون المحدد
//           };
//         });
//     });

//     setEvents(transformedEvents);
//   }

//   return function cleanUp() {
//     context.setAppContentFullHeight(false);
//     context.setAppContentClass('');
//   };
// }, [data, context]);
